import type { ConsumerCreated } from '@easyhelp/shared';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { CopyButton } from './CopyButton';

export interface CredentialsDialogProps {
  open: boolean;
  created: ConsumerCreated;
  onClose: () => void;
}

/**
 * Credenziali del consumer appena creato: `client_id` e `client_secret` con Copia. Il secret non
 * sarà più visibile (DEC-006 §5): se perso, si revoca il consumer e se ne crea uno nuovo.
 */
export function CredentialsDialog({ open, created, onClose }: CredentialsDialogProps) {
  return (
    <Dialog open={open} fullWidth maxWidth="sm" aria-labelledby="credentials-title">
      <DialogTitle id="credentials-title">Credenziali del consumer</DialogTitle>
      <DialogContent>
        <Stack spacing={4} sx={{ pt: 1 }}>
          <Typography>
            {created.name} è registrato. Consegna queste credenziali al team del prodotto, che le conserva nel proprio
            secret manager.
          </Typography>
          <Alert severity="warning">
            Il <code>client_secret</code> è visibile <strong>solo adesso</strong>: chiuso questo dialogo non sarà più
            recuperabile. Se va perso, revoca il consumer e registrane uno nuovo.
          </Alert>
          <CredentialField label="client_id" value={created.clientId} />
          <CredentialField label="client_secret" value={created.clientSecret} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          Ho salvato le credenziali
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function CredentialField({ label, value }: { label: string; value: string }) {
  return (
    <TextField
      label={label}
      value={value}
      fullWidth
      slotProps={{
        input: {
          readOnly: true,
          endAdornment: <CopyButton value={value} label={label} />,
          sx: { fontFamily: (theme) => theme.typography.fontFamilyMonospace },
        },
      }}
    />
  );
}
